export default __webpack_public_path__ + "0b6be46023dd263b5f82a270f8452a46.svg";